module.exports = __webpack_public_path__ + "img/rob_track.8c90f8fc.png";